
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  PropType,
  ref,
  toRef,
  watch,
} from "vue";
import CategoryBox from "@/Components/Rfp/RfpCategoryBox.vue";
import CategoryForm from "@/Components/Rfp/RfpCategoryForm.vue";
import HcButton from "@/Components/Buttons/Button.vue";
import { throttle } from "lodash";
import RfpCategory from "@/types/Rfp/RfpCategory";
import Card from "@/Components/General/Card.vue";
import CardBody from "@/Components/General/CardBody.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import route from "ziggy-js";
import { Inertia } from "@inertiajs/inertia";
import Messages from "@/Components/General/Messages.vue";




interface Props {
  categories: RfpCategory[];
  selectedCategory?: RfpCategory | null;
}

export default defineComponent({
  layout: AppLayout,
  components: {
    Messages,
    CategoryBox,
    CategoryForm,
    HcButton,
    Card,
    CardBody,
  },
  props: {
    categories: {
      type: Object as PropType<RfpCategory[]>,
      required: true,
    },
    selectedCategory: {
      type: Object as PropType<RfpCategory>,
    },
  },
  setup(props: Props) {
    const selectedCategory = toRef(props, "selectedCategory");
    const createNew = ref(route().current("rfp-categories.create"));
    const screenWidth = ref(window.innerWidth);
    const wideScreen = computed(() => {
      return screenWidth.value >= 1024;
    });
    watch(
      () => selectedCategory.value?.id,
      function () {
        if (selectedCategory.value) {
          createNew.value = false;
        }
      }
    );

    const onDeleted = () => {
      Inertia.visit(route("rfp-categories.index"));
    };



    const onResize = throttle((e) => {
      screenWidth.value = e.target.innerWidth;
    }, 100);

    onMounted(() => {
      window.addEventListener("resize", onResize);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", onResize);
    });

    return {
      createNew,
      screenWidth,
      onDeleted,
      wideScreen,
      selectedCategory,
    };
  },
});
